import React from 'react';
import PropTypes from 'prop-types';

import { Field } from 'redux-form';

import CheckboxField from 'components/fields/CheckboxField';

const OrdersTableRowItemSelection = ({ namePrefix, className , disabled }) => (
  <div className={className}>
    <Field
      id={`${namePrefix}.selected`}
      name={`${namePrefix}.selected`}
      component={CheckboxField}
      disabled={disabled}
    />
  </div>
);

OrdersTableRowItemSelection.propTypes = {
  namePrefix: PropTypes.string.isRequired,
  className: PropTypes.string,
  disabled: PropTypes.bool,
};

OrdersTableRowItemSelection.defaultProps = {
  className: '',
  disabled: false,
};

export default OrdersTableRowItemSelection;



// WEBPACK FOOTER //
// ./src/components/workflow/OrdersTable/OrdersTableRowItemSelection.js